import { render, staticRenderFns } from "./QueryResults.vue?vue&type=template&id=4ef79e4c&scoped=true"
import script from "./QueryResults.vue?vue&type=script&lang=js"
export * from "./QueryResults.vue?vue&type=script&lang=js"
import style0 from "./QueryResults.vue?vue&type=style&index=0&id=4ef79e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef79e4c",
  null
  
)

export default component.exports